import { combineReducers } from 'redux';
import alert from './alertReducer';
import auth from './authReducer';
import contact from './contactReducer';
import message from './messageReducer';

export default combineReducers({
  alert,
  auth,
  contact,
  message,
});
